module.exports = __webpack_public_path__ + "static/stone_giant-049cec4092b639f30694dd60f05f507e.jpg";